import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Menu, Button } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined, ExclamationCircleOutlined, HomeOutlined, ExclamationOutlined, ClockCircleOutlined, SettingOutlined, IdcardOutlined    } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { getToken } from '../helpers';

function Sidebar(props) {
	const [mode, setMode] = useState('inline');
	const [theme, setTheme] = useState('light');
	const [collapsed, setCollapsed] = useState(false);
	const token = getToken();

	const toggleCollapsed = () => {
		setCollapsed(!collapsed);
	};

	const getCurrentPath = () => {
		return window.location.pathname.substring(1);
	}
		if (token === '')
			return null;
		return (
			<>
				<Button type="primary" style={{ position: 'absolute', paddingLeft: '28px', textAlign: 'left', width: collapsed ? '72px' : '268px' }} onClick={()=>{toggleCollapsed()}}>
					{React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined )}
				</Button>	
				<Menu
					style={{ marginTop: '30px' }}
					mode={mode}
					inlineCollapsed={collapsed}
					defaultSelectedKeys={[getCurrentPath()]}					
					theme={theme}
				>
					<Menu.Item key="portal" icon={<HomeOutlined />}>
						<Link to="/portal">Inicio</Link>
					</Menu.Item>
					<Menu.Item key="status" icon={<ExclamationOutlined />}>
						<Link to='/status'>Estatus de solicitudes</Link>
					</Menu.Item>
					<Menu.Item key="schedule" icon={<ClockCircleOutlined />}>
						<Link to='/schedule'>Programador Descargas</Link>
					</Menu.Item>
					<Menu.Item key="settings" icon={<SettingOutlined />}>
						<Link to="/settings">Configuración</Link>
					</Menu.Item>
					<Menu.Item key="license" icon={<IdcardOutlined />}>
						<Link to="/license">
							Mi licencia {props.licenseStatus === false && <ExclamationCircleOutlined theme="filled" style={{color:'#FAAD14'}} />}
						</Link>
					</Menu.Item>
				</Menu>
			</>
		)
	}

const mapStateToProps = (state) => {
	return {
		licenseStatus: state.license.licenseStatus.isValid,
	}
}

export default connect(mapStateToProps, null)(Sidebar);
